import React from 'react'
import styles from './Input.module.scss'
import classNames from 'classnames'

type InputProps = {
  label?: string
  value?: string
  onChange?: (v: string | undefined) => void
  containerClassname?: string
  disabled?: boolean
  autoComplete?: boolean
  size?: 'small'
  type?: string
  placeholder?: string
}

const Input = ({ label, value, type = 'text', placeholder, ...props }: InputProps) => {
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value === '' ? undefined : e.target.value
    props.onChange?.(value)
  }

  return (
    <div
      className={classNames([styles.container, { [styles.small]: props.size === 'small' }, props.containerClassname])}>
      <input
        autoComplete={props.autoComplete ? 'on' : 'off'}
        name={label ?? 'input'}
        className={classNames([styles.input, { [styles.withLabel]: label !== undefined }])}
        value={value ? value : ''}
        onChange={onChange}
        disabled={props.disabled}
        type={type}
        placeholder={placeholder}
      />
      {label && (
        <label htmlFor={label} className={styles.label}>
          {label}
        </label>
      )}
    </div>
  )
}

export default Input
